module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/q3_efe1e66d1726a864c1e1ff788a263bca.png";